module.exports = __webpack_public_path__ + "static/media/IMG_2908.495ad7e6.jpg";